import './Footer.css'
import React from 'react'

export default function Footer(props) {
    return (
        <footer className="footer">
            <span>
                Desenvolvido com <i className='fa fa-heart text-danger' /> por Guilherme Henrique
            </span>
        </footer>
    )
}